module.exports = __webpack_public_path__ + "img/1.f9dd25d2.jpg";